import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AutenticacaoService } from './services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private auth: AutenticacaoService) {
  }
  ngOnInit(): void {

    this.router.events.pipe(

      filter(e=>e instanceof NavigationEnd)

    ).subscribe(async ()=>{

      await firstValueFrom(this.auth.isLogadoRefreshSeNao())

    })

  }
  title = 'simcaqvix';
}
